import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, fileUrl } from "../lib/api";

const SettingsContext = createContext({ settings: { app_title: "Jufi", logo: "", favicon: "" } });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({ app_title: "Jufi", logo: "", favicon: "" });

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch (e) {
      /* keep defaults */
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    const link = document.getElementById("app-favicon");
    if (link && settings.favicon) link.href = fileUrl(settings.favicon);
    if (!/^\/[^/]+$/.test(window.location.pathname) || ["/login", "/register", "/dashboard"].includes(window.location.pathname)) {
      document.title = `${settings.app_title} · Jualan Affiliate`;
    }
  }, [settings]);

  return <SettingsContext.Provider value={{ settings, setSettings, reload: load }}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
